import listTemplate from './list/list.pug';
import formTemplate from './form/form.pug';
import viewTemplate from './view/view.pug';

'use strict';

export default ['$stateProvider', function routes($stateProvider) {
  $stateProvider
    .state('group.view.settings.positionType', {
    // /context/:ctxId/groups/:groupId/positiontypes
    // :ctxId = ancestor/context group, :groupId = group
      url: '/positiontypes',
      abstract: true,
      template: '<ui-view />'
    })
    .state('group.view.settings.positionType.list', {
      url: '',
      template: listTemplate,
      controller: 'PositionTypeListCtrl',
      controllerAs: 'ptvm',
      authenticate: true
    })
    .state('group.view.settings.positionType.new', {
      url: '/new',
      template: formTemplate,
      controller: 'PositionTypeFormCtrl',
      controllerAs: 'ptvm',
      authenticate: true
    })
    .state('group.view.settings.positionType.view', {
      url: '/:ptId',
      template: viewTemplate,
      controller: 'PositionTypeViewCtrl',
      controllerAs: 'ptvm',
      authenticate: true
    })
    .state('group.view.settings.positionType.edit', {
      url: '/:ptId/edit',
      template: formTemplate,
      controller: 'PositionTypeFormCtrl',
      controllerAs: 'ptvm',
      authenticate: true
    });
}];
